import { createBrowserRouter } from "react-router";

import RootRoute from "~/routes/root";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootRoute />,
  },
]);
